<template>
  <div>
    <div v-if="lang === 'zh-CN'" class="Section0" style="layout-grid: 15.6pt">
      <p class="MsoNormal" align="center" style="text-align: center">
        <b><span>水母物联服务协议</span></b
        ><b
          ><span>
            <o:p></o:p> </span
        ></b>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>更新日期：2024年10月08日</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>生效日期：2024年10月08日</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>提示条款</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>欢迎您与</span><span>深圳水母物联安全技术有限公司</span
        ><span>（以下简称“</span><span>水母物联</span
        ><span>”或“我们”）共同签署《</span><span>水母物联</span
        ><span>服务协议》（下称“本协议”）并使用</span><span>水母物联</span
        ><span>服务（以下简称“本服务”）！</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span
            >【审慎阅读】您在点击同意前，应当认真阅读以下协议。请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</span
          ></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>1．与您约定免除或限制责任的条款；</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>2．与您约定法律适用和管辖的条款；</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>3．其他以粗体下划线标识的重要条款。</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>【特别提示】</span></b
        ><span> 当您阅读并同意本协议，或者以任一被经营者所允许的方式使用 </span
        ><span>水母物联</span
        ><span>
          服务，或者以其他任何明示或者默示方式表示接受本协议的，即表示您已充分阅读、理解并接受本协议的全部内容,并与 </span
        ><b><span>本服务经营者</span></b
        ><span>达成一致，成为本服务用户。</span
        ><b
          ><span>
            阅读本协议的过程中，如果您不同意本协议或其中任何条款，您应立即停止使用本服务。如果您未满
            18周岁，请在法定监护人的陪同下阅读本协议及其他协议，并在法定监护人陪同下使用本服务。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>【协议更新】</span></b
        ><span>
          我们可能根据服务变化、软件迭代更新及相关法律法规政策的变化不时更新本协议，我们将在协议更新的情况下通过在网页及客户端主页面公示或弹窗提示的方式告知您，如您不接受更新后的部分或全部协议条款，您需要立即停止使用我们的服务；如您在我们更新的协议生效后继续使用我们的服务，则视为您已接受更新后的协议。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>【争议解决】法律适用、管辖与其他</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            您因使用本服务所产生及与本服务有关的争议，任何一方均可向本服务经营者所在地有管辖权的人民法院提起诉讼。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          本协议任一条款被视为废止、无效或不可执行，该条应视为可分割的且并不影响本协议其余条款的有效性及可执行性。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>一、定义</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>水母物联服务：</span></b
        ><span>指以</span><span>水母物联</span
        ><span>品牌智能硬件产品为核心的，由</span><span>水母物联</span
        ><span>向您提供的各项服务，包括但不限于</span><span>水母物联</span
        ><span>商城服务、</span><span>水母物联</span
        ><span>云服务等（以下简称 “本服务”）。</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>经营者：</span></b
        ><span>指</span><span>深圳水母物联安全技术有限公司</span
        ><span>,注册地址为</span
        ><span>深圳市龙岗区宝龙街道宝龙社区南同大道28号贝斯达医疗器械大厦1栋B号厂房1B301</span
        ><span>。</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>用户：</span></b
        ><span>指使用水母物联服务的使用人，在本协议中又称为“您”。</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>二、协议范围</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>2.1 签约主体</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          本协议由您与本服务经营者共同缔结，本协议对您与本服务经营者均具有合同效力。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            <o:p>&nbsp;</o:p>
          </span></b
        >
      </p>
      <p class="MsoNormal">
        <b><span>三、服务说明</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>3.1</span></b
        ><span>
          “水母物联”是一个为用户提供智能硬件产品以及硬件产品的配套软件服务、云增值服务的品牌， </span
        ><span>水母物联</span><span>服务本身不直接产生任何内容。</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>3.2</span></b
        ><span>
          用户注册成功后，将水母物联产品接入水母物联平台，即可实现远程操控智能硬件产品等功能。用户可根据自身需要，自行添加或删除所接入的智能设备。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>3.3</span></b
        ><span>
          用户理解，与使用本服务有关的设备（如电脑、手机、调制解调器、考勤设备及其他与接入互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费）均由用户自行承担。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>四、账户注册与管理（重要条款）</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>4.1 用户资格</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          您确认，在您开始使用本服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力。 </span
        ><b
          ><span>
            若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>4.2账户说明</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得水母物联平台账户并成为水母物联平台用户。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          您有权使用您设置或确认的会员名、邮箱、手机号码（以下简称
          “账户名称”）及您设置的密码（账户名称及密码合称“账户”）登录水母物联平台。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          鉴于水母物联平台部分服务的提供需要结合智能家居硬件、网络摄像机、硬盘录像机、网络录像机、其他报警设备等水母物联提供的终端设备，您可以将上述设备与账户绑定。 </span
        ><b
          ><span>
            由于您的账户关联您的个人信息及本服务可能涉及的商业信息，您的账户仅限您本人使用，不可转让、转授权或以其他任何方式许可他人使用，您须自行对您的账户下的所有活动及其后果承担责任（包括您对直接或间接授权第三方使用您水母物联账户或获取您账户项下信息的行为承担连带责任）。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>4.3 注册信息管理</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>4.3.1 真实合法</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          在使用本服务时，您应当按水母物联平台页面的提示准确完整地提供您的信息（包括您的姓名及电子邮件地址、联系电话、联系地址等），以便我们或其他用户与您联系。 </span
        ><b
          ><span>
            您了解并同意，您有义务保持您提供信息的真实性及有效性。如果您提供的信息不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且
          </span></b
        ><b><span>水母物联</span></b
        ><b><span> 平台保留终止您使用本平台各项服务的权利。 </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span> 您设置的水母物联会员名不得违反国家法律法规及 </span></b
        ><b><span>水母物联</span></b
        ><b><span> 平台规则关于会员名的管理规定，否则我们可回收您的 </span></b
        ><b><span>水母物联</span></b
        ><b><span>会员名。</span></b
        ><span>
          水母物联会员名的回收不影响您以邮箱、手机号码登录水母物联平台并使用 </span
        ><span>水母物联</span><span>服务。</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>4.3.2 更新维护</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          您应当及时更新您提供的信息，提供最新、真实、完整、有效的信息。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>4.4账户安全</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>4.4.1</span></b
        ><span>
          您的登录账户信息（如手机号码或验证码）由您保管，我们任何时候均不会主动要求您提供您的账户信息。因此，建议您务必保管好您的账户信息，并确保您在每个上网时段结束时退出登录并以正确步骤离开本服务。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            账户信息因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，我们并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            4.4.2您应对您使用本服务时提供的数据（包括个人信息）来源及内容负责，因您提供、使用的数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。除我们存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、发布信息、购买商品及服务及披露信息等）负责。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>4.4.3</span></b
        ><span>
          如发现任何未经授权使用您账户登录本服务或其他可能导致您账户遭窃、遗失的情况，建议您立即通知我们。 </span
        ><b
          ><span>
            您理解我们对您的任何请求采取行动均需要合理时间，且我们应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除我们存在法定过错外，我们不承担责任。
          </span></b
        ><b
          ><span>
            <o:p></o:p> </span
        ></b>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>五、服务使用规则</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>5.1</span></b
        ><span
          >您知悉
          “水母物联”服务仅供您非商业性质的使用。您未经我们书面同意，利用“水母物联”各项服务进行销售或其他商业用途的，我们可立即终止服务，并依法追究其法律责任。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>5.2</span></b
        ><span>您在使用本服务时必须遵守以下原则：</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（1）遵守国家有关法律和政策；</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（ 2）遵守所有与网站服务有关的网络协议、规定和程序； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（3）仅通过我们声明的合法通道登录使用；</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（ 4）不得利用本服务进行任何不利于我们的行为； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          >（
          5）不得利用本服务进行任何可能对互联网的正常运转造成不利影响的行为； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          >（
          6）不得删除本服务涉及的软件及其他副本上关于版权的信息、内容。修改删除或避开我们为保护知识产权而设置的任何技术措施； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          >（
          7）未经我们的书面同意，您不得擅自将本服务涉及的软件出租、出借或再许可给第三方使用； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          >（
          8）不得以任何方式使用该等信息或材料，也不得对本服务涉及的软件进行复制、翻译、分解或反编译或制造其衍生作品，亦不得以反向工程或其他方法将软件的目标代码转换或试图转换源代码。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          >（
          9）除本协议另有约定外，不得以任何形式或任何方式对本服务部分或全部内容进行修改、出租、出售、分发、复制、创作衍生品或用于其他任何商业用途； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（10）不得为任何非法目的使用本服务；</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          >（ 11）不使用外挂或者其他作弊手段、不正当或不公平手段使用本服务； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          >（ 12）不得以任何方式触犯法律、或者侵犯他人隐私、或者诋毁他人； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span
          >（ 13）如发现账户被非法使用或出现安全漏洞的情况，应立即通知我们。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>5.3</span></b
        ><span>
          我们保留随时升级、调整本服务内容的权利。本服务软件版本升级、调整后，可能涉及浏览器插件、手机客户端、终端设备软件版本的升级；我们也可能对浏览器插件、手机客户端软件、终端设备软件等单独进行升级。您应根据提示对涉及的软件进行升级，否则您将不能享受新版本提供的功能、且我们不保证旧版本的继续可用。另外， </span
        ><b
          ><span>
            我们保留因业务发展需要，单方面对部分功能效果进行改变或进行限制的权利，您同意自行承担以上风险。
          </span></b
        ><b
          ><span>
            <o:p></o:p> </span
        ></b>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            <o:p>&nbsp;</o:p>
          </span></b
        >
      </p>
      <p class="MsoNormal">
        <b><span>六、知识产权</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>6.1</span></b
        ><span>
          除为使用本服务而享有有限的使用权利之外，本协议并不授予您： </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（i）对服务中的知识产权的任何权利，或者</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（ ii）任何使用我们商标、标志、域名或其他品牌特征的权利。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          “知识产权”指世界范围内目前和未来的专利权、版权、商业秘密、商标权和其他类似权利。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            6.2您理解并同意，在使用本平台及相关服务时发布上传的文字、图片、视频、等均由您原创或已获合法授权（含转授权）且不存在违反法律法规的内容，并授权我们为运营、宣传推广本平台及服务之目的在全世界范围、永久无偿使用。您通过本平台上传、发布的任何内容的知识产权归属您或原始著作权人所有。
          </span></b
        ><b
          ><span>
            <o:p></o:p> </span
        ></b>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>七、第三方软件和应用程序</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>7.1</span></b
        ><span>
          本服务中可能有第三方所有和运营的第三方软件和应用程序。我们不拥有这些第三方软件和应用程序的版权或知识产权。鉴于此， </span
        ><b
          ><span>
            您使用第三方软件或应用程序时，应另行与该第三方达成服务协议，支付相应费用并承担可能的风险。
          </span></b
        ><span>
          您应理解我们并无权在本协议中授予您使用该等服务的任何权利，也无权对该等服务提供任何形式的保证。我们无法对该等服务提供客户支持，如果您需要获取支持，您可直接与该第三方联系。因您使用该等服务引发的任何纠纷，您可直接与该第三方协商解决。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>7.2</span></b
        ><span>
          若使用这些第三方软件和应用程序，表示您承认这些第三方软件和应用程序以
          “现状”提供。且在适用法律的最大许可范围内，不附有任何形式（无论是明示还是默示）的保证。您还承认，我们及其母子公司都不作任何明示或默示的陈述或保证，包括但不限于对第三方软件和应用程序的所有权、适销性或对特定用途的适用性或不侵犯第三方专利权、版权、商标或其他权利的保证。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>7.3</span></b
        ><span>
          第三方软件和应用程序的服务可能中断或终止，我们无法保证许可软件将会永久地使用或包含该等服务，也无法保证将来不会使用或包含该第三方的同类型或不同类型的软件或服务或其他第三方的软件或服务，一旦我们在许可软件中使用或包含前述软件或服务，相应的软件或服务同样适用本条约定。我们不保证任何内容或服务可在任何期间维持其可用性。第三方系通过我们可控制范围外的网络及传输工具传输内容或服务。在相关法律允许的范围内，我们明确表示不对通过本产品提供的任何内容或服务的中断或终止承担任何责任。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>7.4</span></b
        ><span>
          对于您个人通过本服务上传、下载的任何文字、图片、视频或软件等第三方作品，我们不对其合法性、质量以及其他任何方面承担任何责任，对于您因个人安装或上传、下载前述第三方作品产生的任何后果，由您自行承担一切相关风险。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>八、有限担保</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>8.1</span></b
        ><span>
          尽管我们希望提供一流的服务，但是我们不能保证与服务相关的某些事项。例如，服务和软件照
          “原样”提供，用户自担风险，无任何形式的明示或暗示的担保或条件。我们同时否认任何适销性、特定用途适用性、稳定性、无病毒、无疏忽、无技术瑕疵问题或不侵权性的担保。对于您访问或使用服务或软件造成的计算机系统损坏、数据丢失或损坏、或者其他损害，我们概不负责。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>8.2</span></b
        ><span>
          您理解本服务涉及互联网，可能会受到各个环节不稳定因素的影响，存在因不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、用户关机、非法内容信息、骚扰信息屏蔽以及其他任何网络、技术、通信线路、电脑故障、信息安全管理措施等原因造成的服务中断、受阻等不能满足用户需求的风险。 </span
        ><b
          ><span>
            您同意自行承担以上风险，对于您因此不能接收视频数据、或接收错误数据等遭受的一切损失，我们无须承担任何责任。
          </span></b
        ><b
          ><span>
            <o:p></o:p> </span
        ></b>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>九、责任限制（重要条款）</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            9.1我们承担的所有责任以您购买本服务所支付的价款为限。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>9.2</span></b
        ><span>
          除法律法规有明确规定外，我们将尽最大努力确保本服务所涉软件及所涉及的技术及信息安全、有效、准确、可靠，但受限于现有技术，您理解我们不能对此进行担保。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            9.3
            在适用法律允许的最大范围内，我们不就您因使用本服务引起的，或在任何方面与该服务有关的，任何意外的、非直接的、特殊的、或惩罚性的损害或请求(包括但不限于因人身伤害、因隐私泄漏、因未能履行包括诚信或合理谨慎在内的任何责任)承担任何责任。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            9.4本服务可能包含第三方网站或资源的链接。我们不保证这些链接的可用性、准确性、相关内容、产品和服务，也不对此负责。您应对使用任何该类网站或资源的行为负全部责任。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            9.5我们依照法律规定履行基础保障义务，但对于下述原因导致的合同履行障碍、履行瑕疵、履行延后或履行内容变更等情形，我们并不承担相应的违约责任：
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            （一）因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            （二）因电力供应故障、通讯网络故障等公共服务因素或黑客攻击等第三人因素；
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            （三）在我们已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>9.6</span></b
        ><span>
          非经我们或我们授权开发并正式发布的其它任何由本服务软件衍生的软件均属非法，下载、安装、使用此类软件，可能导致不可预知的风险，由此产生的法律责任与纠纷与我们无关，我们有权中止、终止使用许可和
          /或其他一切服务。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>9.7</span></b
        ><span>
          您与其他使用本服务软件的用户之间通过本服务软件进行交流互动时，因您受误导或欺骗而导致或可能导致的任何心理、生理上的伤害以及经济上的损失，均应由过错方依法承担所有责任。 </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>十、终止服务与赔偿（重要条款）</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            10.1您应理解按授权范围使用本服务软件、尊重本服务软件及本服务软件包含内容的知识产权、按规范使用软件、按本协议约定履行义务是您获取我们授权使用本软件的前提，如您严重违反本协议，我们将终止提供本服务。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            10.2您对本服务的使用有赖于我们或我们关联公司为您提供的配套服务，您或组织违反与我们或我们关联公司的条款、协议、规则、通告等相关规定，而被我们或我们关联公司终止提供配套服务的，可能导致您无法正常使用本服务。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            10.3您理解出于维护平台秩序及保护消费者权益的目的，如果您向我们及（或）我们的关联公司作出任何形式的承诺，且相关公司已确认您违反了该承诺并通知我们依据您与其相关约定进行处理的，则我们可按您的承诺或协议约定的方式对您的使用本服务及其他我们可控制的权益采取限制措施，包括中止或终止提供本服务。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            10.4一旦您违反本协议或与我们签订的其他协议的约定，我们可通知我们关联公司，要求其对您的权益采取限制措施，包括要求关联公司中止、终止对您提供部分或全部服务，且在其经营或实际控制的网站依法公示您的违约情况。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            10.5本服务软件由您自下载平台下载取得，您需要遵守下载平台、系统平台、终端厂商对您使用许可软件方式与限制的约定，如果上述第三方确认您违反该约定需要我们处理的，我们可能会因第三方要求终止对您的使用许可。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            10.6在本服务终止时，您应停止对本服务软件的使用行为,
            并销毁本服务软件的全部副本。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            10.7如您的行为使我们及/或我们关联公司遭受损失（包括自身的直接经济损失、商誉损失及对外支付的赔偿金、和解款、律师费、诉讼费等间接经济损失），您应赔偿我们及/或我们关联公司的上述全部损失。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            10.8如您的行为使我们及/或我们关联公司遭受第三人主张权利，我们及/或其关联公司可在对第三人承担金钱给付等义务后就全部损失向您追偿。
          </span></b
        ><b
          ><span>
            <o:p></o:p> </span
        ></b>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>十一、 通知</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>11.1联系方式</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>您可以通过以下方式联系我们：</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>1. 联系电话：</span></b
        ><span>010-56100119</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            <o:p>&nbsp;</o:p>
          </span></b
        >
      </p>
      <p class="MsoNormal">
        <b><span>十二、 协议的终止</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>12.1 终止的情形</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>您有权通过以下任一方式终止本协议：</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span> （一）变更事项生效前您停止使用并明示不愿接受变更事项的； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（二）您决定停止使用本服务的。</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>出现以下情况时，我们可以终止本协议：</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span> （一）您违反本协议约定，我们依据违约条款终止本协议的； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span> （二）您盗用他人账户、发布违禁信息、骗取他人财物的； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（三）除上述情形外，因您多次违反</span><span>水母物联</span
        ><span>平台规则相关规定且情节严重的；</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span> （四）侵犯他人合法权益或其他严重违法违约行为的； </span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>（五）其它应当终止服务的情况。</span
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b><span>12.2 协议终止后的处理</span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            本协议终止后，除法律有明确规定外，我们无义务向您或您指定的第三方披露您账户中的任何信息。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <b
          ><span>
            本协议终止后，对于您在本协议存续期间产生的交易订单，我们可自行决定是否关闭该等交易订单；如我们要求继续履行的，则您应当就该等交易订单继续履行本协议及交易订单的约定，并承担因此产生的任何损失或增加的任何费用。
          </span></b
        ><span>
          <o:p></o:p>
        </span>
      </p>
      <p class="MsoNormal">
        <span>
          <o:p>&nbsp;</o:p>
        </span>
      </p>
    </div>
    <article v-else-if="documentData" class="Section0 legal-document" :lang="lang">
      <h1>{{ documentData.title }}</h1>
      <p class="document-meta"><strong>{{ documentData.updated }}</strong></p>
      <p class="document-meta"><strong>{{ documentData.effective }}</strong></p>
      <section class="introduction">
        <p v-for="(paragraph, index) in documentData.introduction" :key="`intro-${index}`">{{ paragraph }}</p>
      </section>
      <section v-for="(section, sectionIndex) in documentData.sections" :key="`section-${sectionIndex}`">
        <h2>{{ section.title }}</h2>
        <p v-for="(paragraph, paragraphIndex) in section.paragraphs" :key="`paragraph-${sectionIndex}-${paragraphIndex}`">{{ paragraph }}</p>
      </section>
    </article>
  </div>
</template>

<script setup>
import { computed, watchEffect } from 'vue';
import { useRoute } from 'vue-router';
import { userAgreementDocuments } from './legalDocuments.js';

const route = useRoute();
const normalizeLang = (value) => (['zh-CN', 'en', 'zh-TW'].includes(value) ? value : 'zh-CN');
const lang = computed(() => normalizeLang(Array.isArray(route.query.lang) ? route.query.lang[0] : route.query.lang));
const documentData = computed(() => userAgreementDocuments[lang.value]);

watchEffect(() => {
  if (typeof document === 'undefined') return;
  document.documentElement.lang = lang.value;
  document.title = documentData.value?.title || '水母物联服务协议';
});
</script>

<style scoped>
.Section0 {
  padding: 40px 15px 50px;
}

body {
  font-family: Arial, sans-serif;
  margin: 0;
  /* padding: 20px; */
}

h1,
h2,
h3 {
  color: #333;
}

p {
  margin-bottom: 15px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
}

.legal-document { max-width: 920px; margin: 0 auto; color: #222; font-family: Arial, "PingFang TC", "Microsoft JhengHei", sans-serif; font-size: 16px; line-height: 1.75; }
.legal-document h1 { margin: 0 0 28px; text-align: center; font-size: 28px; }
.legal-document h2 { margin: 32px 0 12px; font-size: 20px; }
.legal-document p { margin: 0 0 15px; }
.document-meta { margin-bottom: 6px !important; }
.introduction { margin-top: 28px; }
</style>
